import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { CmsDynamicPuffCollectionComponent } from '../../../core/model';
import { CmsContentTagService } from '../../cms-content-tag-base';

@Component({
  selector: 'py-dynamic-puff-collection',
  templateUrl: './dynamic-puff-collection.component.html',
  styleUrls: ['./dynamic-puff-collection.component.scss'],
  standalone: false,
})
export class DynamicPuffCollectionComponent implements OnInit {
  constructor(
    public cmsComponent: CmsComponentData<CmsDynamicPuffCollectionComponent>,
    private cmsContentTagService: CmsContentTagService,
    private route: ActivatedRoute
  ) {}

  taggedPuffs$: Observable<Array<string>>;
  puffUids: string[] = [];
  componentData: CmsDynamicPuffCollectionComponent;

  ngOnInit(): void {
    this.getTaggedPuffs();
  }

  getTaggedPuffs(tags: string[] = []): void {
    this.taggedPuffs$ = this.cmsComponent.data$.pipe(
      filter((data) => !!data.masterTag),
      switchMap((data) => {
        this.componentData = data;
        tags = tags?.length > 0 ? tags : this.componentData?.contentTags?.split(' ');
        return this.cmsContentTagService.findUIDsForMasterTagAndFilterTags(
          data?.masterTag,
          'PuffComponent',
          'priority-desc,name-asc',
          tags?.join(',') || this.route.snapshot.queryParamMap.get('f') || ''
        );
      })
    );
  }

  onSetPuffUids(puffUids: string[]): void {
    this.puffUids = puffUids;
  }
}
